/**
 * Resource file for all the string used to display
 */
export class Resource {
  public static OPEN_NEW_TAB: string = 'Open in new tab';
  public static CLOSE: string = 'Close';
  public static API_CALL_FAILED: string = 'API call failed';
  public static ACCURATE_QUESTION: string = 'Accurate?';
  public static TIME_SAVED: string = 'Time saved';
  public static IN_MINUTES: string = 'In minutes';
  public static TABULAR_VIEW: string = 'Tabular View';
  public static ERROR_MESSAGE: string = 'You shall not pass! 🧙‍♂️';
  public static ERROR_WITH_MESSAGE: string = 'Error:';
  public static SUMMARY: string = 'Summary';
  public static DATE_REQUESTED: string = 'Date ordered';
  public static DOCTOR_INFO: string = 'Doctor’s Info';
  public static ORDERING_STATUS: string = 'Ordering Status';
  public static UPDATE_DOCTOR_INFO: string = 'Update Doctor’s Info';
  public static DOCTOR_INFO_HEADER: string = 'DOCTOR’S INFO';
  public static EXAMONE_STATUS_UPDATES: string = 'Examone Status';
  public static DOCTOR_INFO_NOT_PROVIDED: string =
    'No doctor information provided';
  public static FILES: string = 'File(s)';
  public static EVIDENCE: string = 'Evidences';
  public static DESCRIPTION: string = 'Description';
  public static QUESTIONS: string = 'Questions';
  public static QUESTIONS_HEADER: string = 'QUESTIONS';
  public static REASON: string = 'Reason';
  public static INFO: string = 'Information';
  public static BACK: string = 'Back';
  public static CANCEL: string = 'Cancel';
  public static PHYSICAL_MEASUREMENT: string = 'Physical Measurements';
  public static TYPE: string = 'TYPE';
  public static EKG: string = 'EKG';
  public static LABS: string = 'Labs';
  public static NA: string = 'NA';
  public static TASK_ID: string = 'Task ID';
  public static TASK_TITLE_APS: string = 'APS';
  public static TASK_TITLE_EHR: string = 'EHR';
  public static TASK_TITLE_ETI: string = 'ETI';
  public static TASK_TITLE_RULE_REVIEW: string = 'Rule Review';
  public static TASK_TITLE_MEDEXAM: string = 'Medical Exam';
  public static TASK_TITLE_ORDER_MIB_CODEBACK: string = 'Order Codebacks';
  public static TASK_TITLE_MIB_CODEBACK: string = 'Codebacks';
  public static TASK_TITLE_DECISION: string = 'Decision';
  public static TASK_TITLE_OVERVIEW: string = 'Overview';
  public static TASK_TITLE_PII_DATA: string = 'PII Data';
  public static TASK_TITLE_LINKED_POLICIES = 'Linked Policies';
  public static TASK_TITLE_STACKED_POLICIES = 'Stacked Policies';
  public static TASK_TITLE_EXISTING_POLICIES = 'Existing Policies';
  public static TASK_TITLE_PAST_APPLICATIONS = 'Past Applications';
  public static TASK_TITLE_PIA: string = 'Post issue audit';
  public static TASK_TITLE_DISCLOSURE: string = 'Disclosures';
  public static TASK_DETAILS_TITLE_QE_INTERVIEW_QA: string = 'Application Q&A';
  public static TASK_TITLE_NOTES: string = 'Notes';
  public static TASK_TITLE_LAB_PIQTURE = 'LabPiQture';
  public static TASK_TITLE_MEDICAL_CLAIMS = 'Medical Claims';
  public static TASK_TITLE_SCRIPT_CHECK = 'ScriptCheck';
  public static TASK_TITLE_MIB_CODE_DETAILS = 'MIB Code Details';
  public static TASK_TITLE_INSURANCE_LABS = 'Insurance Labs';
  public static TASK_TITLE_CRIMINAL_RECORDS = 'Criminal Records';
  public static TASK_TITLE_ADDITIONAL_CUSTOMER_INFO = 'Info From Customer';
  public static TASK_TITLE_SPECIAL_AUTHORIZATION = 'Special Authorization';
  public static TASK_TITLE_PLAN_F = 'Plan F';
  public static TASK_TITLE_DISPUTE: string = 'Dispute';
  public static TASK_TITLE_CARRIER_ELIGIBILITY = 'Carrier Eligibility';
  public static TASK_TITLE_AUTO_MEDICAL_CLAIMS = 'Automated Medical Claims';
  public static TASK_TITLE_REINSTATEMENT_APPLICATION =
    'Reinstatement Application';
  public static TASK_TITLE_APS_SUMMARY = 'APS Summary';
  public static TASK_TITLE_EHR_SUMMARY = 'EHR Summary';
  public static TASK_TITLE_ADDITIONAL_DATA = 'Additional Data';
  public static DOCTOR_INFO_TITLE = 'Doctor Info';
  public static REINSTATEMENT_APPLICATION = 'Reinstatement Application';
  public static RULE_RESULTS_TITLE = 'Rule Results';
  public static NORA_SEPARATOR: string = ' · ';
  public static NORA_M_DASH = '—';
  public static NORA_NOT_APPLICABLE = 'N/A';
  public static ORDER_REASON: string = 'Order reason';
  public static OTAF_REASON: string = 'OTAF REASON';
  public static AMENDMENT: string = 'AMENDMENT';
  public static YES_STRING: string = 'Yes';
  public static NO_STRING: string = 'No';
  public static LOADING: string = 'Loading';
  public static EVIDENCE_OUTDATED: string = 'outdated';
  public static EVIDENCE_REPULLED: string = 'repulled';
  /* APPROVE/DECLINE/UPDATE DECISION START*/
  public static APPROVE_APPLICATION_HEADER: string = 'Approve Application';
  public static DECLINE_APPLICATION_HEADER = 'Decline Application';
  public static POSTPONE_APPLICATION_HEADER = 'Postpone Application';
  public static RESCIND_REASON = 'RECISION REASON';
  public static INELIGIBLE_APPLICATION_HEADER: string =
    'Ineligible Application';
  public static INELIGIBLE_REVIEW_APPLICATION_HEADER: string = 'No Decision';
  public static UPDATE_DECISION_HEADER = 'Update Decision';
  public static DISAGREE_TO_RESCIND = 'Disagree to rescind';
  public static AGREE_TO_RESCIND = 'Agree to rescind';
  public static DISAGREE_TO_REINSTATE = 'Deny to reinstate';
  public static AGREE_TO_REINSTATE = 'Agree to reinstate';
  public static WITHDRAW_REINSTATEMENT = 'Withdraw Reinstatement';

  public static DISAGREE_WITH_PRELIM = 'Disagree with prelim';
  public static AGREE_WITH_PRELIM = 'Agree with prelim';
  public static EDIT_DECISION = 'Edit decision';
  public static WAIVE_DECISION = 'Waive decision';
  public static WAIVE_REASON = 'Waive reason';
  public static REVIEW_DECISION = 'Review Decision';
  public static CONFIRM_DECISION = 'Confirm Decision';
  public static REVIEW_APPROVAL = 'Review Approval';
  public static REVIEW_APPLICATION = 'Review Application';
  public static UPDATE_REASON_HEADER = 'REASON FOR UPDATE';
  public static APPROVE_OPTION = 'Approve';
  public static POSTPONE_OPTION = 'Postpone';
  public static DECLINE_OPTION = 'Decline';
  public static INELIGIBLE_OPTION = 'Ineligible';
  public static WAIVED_OPTION = 'Waive';
  public static DECISION_HEADER = 'DECISION';
  public static POSTPONE_HEADER = 'POSTPONE';
  public static NO_DECISION_TO_EDIT = 'Latest decision cannot be edited';
  public static DECLINE_REASON: string = 'DECLINE REASON';
  public static POSTPONE_REASON: string = 'POSTPONE REASON';
  public static DECLINE_CONDITIONS = 'DECLINE CONDITIONS';
  public static POSTPONE_CONDITIONS = 'POSTPONE CONDITIONS';
  public static INELIGIBLE_REASON: string = 'Ineligible Reason';
  public static INELIGIBLE_REASON_NO_EVIDENCE_FOUND: string =
    'No evidence found';
  public static INELIGIBLE_REASON_INSUFFICIENT_EVIDENCE: string =
    'Insufficient evidence';
  public static INELIGIBLE_REASON_EVIDENCE_NOT_RECENT_ENOUGH: string =
    'Evidence not recent enough';
  public static INVALID_TASK_STATE_ERROR: string =
    'Before making a decision, please review all tasks and mark as completed or waived.';
  public static DOCTOR_INFO_PIA: string = `DOCTOR'S INFO (POST ISSUE APS)`;
  public static APPROVE_AT: string = 'APPROVE AT';
  public static RIDERS: string = 'RIDERS';
  public static ELIGIBLE_RIDERS: string = 'ELIGIBLE RIDERS';
  public static INELIGIBLE_RIDERS: string = 'INELIGIBLE RIDERS';
  public static MIB_CODES: string = 'MIB CODES';
  public static WAIVED_DECISION_DESCRIPTION: string =
    'Waiving Post Issue Audit Decision';
  public static MIB_CODE = 'MIB code';
  public static ADD_CUSTOMER_INFO = 'Additional Information';
  public static NOTE = 'Note';
  public static ADD_NOTE = 'Add note';
  public static APPROX_LAB_DATE = 'Date of Labs';
  public static STACKED_POLICY_NOT_FOUND_ERROR =
    'Failed to find infomation for this stacked policy';
  /* APPROVE/DECLINE DECISION END */

  /* TRL SECTION START */
  public static TASK_TITLE_TRL: string = 'TRL';
  public static TRL_APPLICANT_SUBTITLE: string = 'Applicant';
  public static TRL_APPLICANT_HIT_TYPE: string = 'Hit Type';
  public static TRL_APPLICANT_HIT_TYPE_NO_HIT_KEY: string = 'noHit';
  public static TRL_APPLICANT_HIT_TYPE_NO_HIT_VALUE: string = 'No Hit';
  public static TRL_APPLICANT_HIT_TYPE_REGULAR_HIT_KEY: string = 'regularHit';
  public static TRL_APPLICANT_HIT_TYPE_REGULAR_HIT_VALUE: string =
    'Regular Hit';
  public static TRL_APPLICANT_NAME: string = 'Name';
  public static TRL_APPLICANT_BIRTH_DATE: string = 'Birthdate';
  public static TRL_APPLICANT_SSN: string = 'SSN';
  public static TRL_APPLICANT_SSN_EXACT_KEY: string = 'exact';
  public static TRL_APPLICANT_SSN_EXACT_VALUE: string = 'Exact Match';
  public static TRL_SCORE_SUBTITLE: string = 'TRL Score';
  public static TRL_SCORE_SCORE: string = 'Score';
  public static TRL_SCORE_NO_SCORE: string = 'No Score';
  public static TRL_CODES: string = 'Codes';
  public static TRL_SCORE_REASON_SUBJECT_DECEASED_KEY: string =
    'Subject Deceased';
  public static TRL_SCORE_REASON_SUBJECT_DECEASED_VALUE: string =
    'Subject Deceased';
  public static TRL_CREDIT_SUBTITLE: string = 'Credit';
  public static TRL_CREDIT_CREDIT_DATA_SUPPRESSED: string =
    'Credit Data Suppressed';
  public static TRL_CREDIT_CREDIT_FREEZE: string = 'Credit Freeze';
  public static TRL_CREDIT_MINOR: string = 'Minor';
  public static TRL_CREDIT_DO_NOT_PROMOTE: string = 'Do Not Promote';
  public static TRL_CREDIT_DISPUTED: string = 'Disputed';
  public static TRL_CREDIT_ON_FILE_SINCE: string = 'On File Since';
  public static TRL_ADDRESS_SUBTITLE: string = 'Address';
  public static TRL_ADDRESS_STATUS_KEY: string = 'status';
  public static TRL_ADDRESS_STATUS: string = 'Status';
  public static TRL_ADDRESS_STATUS_CURRENT: string = 'Current';
  public static TRL_ADDRESS_STATUS_PREVIOUS: string = 'Previous';
  public static TRL_ADDRESS_TYPE_KEY: string = 'type';
  public static TRL_ADDRESS_TYPE: string = 'Type';
  public static TRL_ADDRESS_TYPE_PERSONAL: string = 'Personal';
  public static TRL_ADDRESS_TYPE_BUSINESS: string = 'Business';
  public static TRL_ADDRESS_ADDRESS_KEY: string = 'address';
  public static TRL_ADDRESS_ADDRESS: string = 'Address';
  public static TRL_ADDRESS_ON_FILE_SINCE_KEY: string = 'onFileSince';
  public static TRL_ADDRESS_ON_FILE_SINCE: string = 'On File Since';
  public static TRL_EMPLOYMENT_SUBTITLE: string = 'Employment';
  public static TRL_EMPLOYMENT_EFFECTIVE_KEY: string = 'effective';
  public static TRL_EMPLOYMENT_EFFECTIVE: string = 'Effective';
  public static TRL_EMPLOYMENT_EMPLOYER_KEY: string = 'employer';
  public static TRL_EMPLOYMENT_EMPLOYER: string = 'Employer';
  public static TRL_EMPLOYMENT_OCCUPATION_KEY: string = 'occupation';
  public static TRL_EMPLOYMENT_OCCUPATION: string = 'Occupation';
  public static TRL_EMPLOYMENT_ON_FILE_SINCE_KEY: string = 'onFileSince';
  public static TRL_EMPLOYMENT_ON_FILE_SINCE: string = 'On File Since';
  /* TRL SECTION END */

  /* DISCLOSURE SECTION START */
  public static DISCLOSURE_SUBTITLE: string = 'Disclosure facts';
  public static DISCLOSURE_INITIAL_PAGE_SIZE: number = 12;
  public static DISCLOSURE_SHOW_ALL: string = 'Show all';
  public static DISCLOSURE_SHOW_LESS: string = 'Show less';
  /* DISCLOSURE SECTION END */

  /* MVR SECTION START */
  public static TASK_TITLE_MVR: string = 'MVR';
  public static MVR_APPLICANT_SUBTITLE: string = 'Applicant';
  public static MVR_APPLICANT_NAME: string = 'Name';
  public static MVR_APPLICANT_GENDER_AND_AGE: string = 'Gender and Age';
  public static MVR_APPLICANT_BIRTH_DATE: string = 'Birthdate';
  public static MVR_APPLICANT_ADDRESS: string = 'Address';
  public static MVR_LICENSE_SUBTITLE: string = 'Drivers License';
  public static MVR_LICENSE_STATE: string = 'License State';
  public static MVR_LICENSE_NUMBER: string = 'License No.';
  public static MVR_LICENSE_CLASS: string = 'Class';
  public static MVR_LICENSE_ISSUED: string = 'Issued';
  public static MVR_LICENSE_EXPIRES: string = 'Expires';
  public static MVR_LICENSE_STATUS: string = 'Status';
  public static MVR_LICENSE_RESTRICTIONS: string = 'Restrictions';
  public static MVR_LICENSE_MISCELLANEOUS: string = 'Miscellaneous Info';
  public static MVR_DRIVERS_RECORD_SUBTITLE: string = 'Drivers Record';

  public static MVR_DRIVERS_RECORD_CLASS: string = 'Class';
  public static MVR_DRIVERS_RECORD_CLASS_KEY: string = 'violationClass';
  public static MVR_DRIVERS_RECORD_VS_DATE: string = 'V/S Date';
  public static MVR_DRIVERS_RECORD_VS_DATE_KEY: string = 'suspensionDate';
  public static MVR_DRIVERS_RECORD_VCODE_KEY: string = 'standardViolationCode';
  public static MVR_DRIVERS_RECORD_VCODE: string = 'V/C Code';
  public static MVR_DRIVERS_RECORD_STATE_VCODE_KEY: string =
    'stateViolationCode';
  public static MVR_DRIVERS_RECORD_STATE_VCODE: string = 'State Code';
  public static MVR_DRIVERS_RECORD_POINTS_KEY: string = 'points';
  public static MVR_DRIVERS_RECORD_POINTS: string = 'Points';
  public static MVR_EVC_KEY: string = 'providerCode';
  public static MVR_EVC: string = 'EVC Code';
  public static MVR_DRIVERS_RECORD_DESCRIPTION_KEY: string = 'description';
  public static MVR_DRIVERS_RECORD_DESCRIPTION: string = 'Description';
  public static MVR_DRIVERS_RECORD_REINSTATEMENT_KEY: string =
    'reinstatementDate';
  public static MVR_DRIVERS_RECORD_REINSTATEMENT: string = 'C/R Date';
  public static MVR_CLASSIFICATION: string = 'Classification';
  public static MVR_DESCRIPTION: string = 'Description';
  public static MVR_STATUS_CLEAR: string = 'CLEAR';
  public static MVR_STATUS_HIT: string = 'HIT';
  public static MVR_VIOLATION_CATEGORY_KEY: string = 'violationCategory';
  public static MVR_VIOLATION_CATEGORY: string = 'EVC Description';
  public static MVR_VIOLATION_DISPOSITION_KEY: string = 'disposition';
  public static MVR_VIOLATION_DISPOSITION: string = 'Disposition';

  public static MVR_NO_RECORD: string = 'No person found in MVR';
  public static MVR_CLEAR: string = 'MVR Record Clear';
  public static MVR_NO_RATABLE_VIOLATIONS: string =
    'No ratable action found in MVR';
  public static MVR_LICENSE_STATE_LABEL: string = 'State';
  public static MVR_VIOLATIONS_SUFFIX: string = 'violations';
  public static MVR_VIOLATION_SUFFIX: string = 'violation';
  public static MVR_REAL_ID: string = 'Real ID';
  public static MVR_TOTAL_STATE_POINTS: string = 'Total State Points';
  public static MVR_PREVIOUS_LICENSES: string = 'Previous Licenses';
  public static MVR_CR_LABEL: string = 'CR';
  /* MVR SECTION END */

  /* MIB SECTION START */
  public static TASK_TITLE_MIB: string = 'MIB Report';
  public static MIB_NO_RECORD: string = 'No person found in MIB';
  public static TRL_NO_RECORD: string = 'No person found in TRL';
  public static MIB_APPLICANT_NAME: string = 'Name';
  public static MIB_APPLICANT_GENDER_AND_AGE: string = 'Gender & Age';
  public static MIB_APPLICANT_BIRTH_DATE: string = 'Birthdate';
  public static MIB_INQUIRY_DETAILS_SUBTITLE: string = 'Inquiry Details';
  public static MIB_RESPONSES_SUBTITLE: string = 'Responses';
  public static MIB_TAB_HITS: string = 'HITs';
  public static MIB_TAB_TRYS: string = 'TRYs';
  public static MIB_RESULT_HIT_VALUE: string = 'HIT';
  public static MIB_SECTION_SUBTITLE_PREFIX: string = 'Response';
  public static MIB_RESULT_RESULT: string = 'Result';
  public static MIB_RESULT_NAME: string = 'Name';
  public static MIB_RESULT_GENDER_AND_AGE: string = 'Gender & Age';
  public static MIB_RESULT_BIRTH_DATE: string = 'Birthdate';
  public static MIB_RESULT_BIRTH_PLACE: string = 'Birthplace';
  public static MIB_RESULT_OCCUPATION: string = 'Occupation';
  public static MIB_CODES_SUBTITLE: string = 'Codes';
  public static MIB_CODES_DATE_KEY: string = 'date';
  public static MIB_CODES_DATE: string = 'Date';
  public static MIB_CODES_CODE_KEY: string = 'code';
  public static MIB_CODES_CODE: string = 'Code';
  public static MIB_IAI_SUBTITLE: string = 'IAI';
  public static MIB_IAI_DATE_KEY: string = 'date';
  public static MIB_IAI_DATE: string = 'Date';
  public static MIB_IAI_INQUIRY_KEY: string = 'inquiry';
  public static MIB_IAI_INQUIRY: string = 'Inquiry';
  public static MIB_IAI_LINE_KEY: string = 'line';
  public static MIB_IAI_LINE: string = 'Line';
  public static MIB_IAI_TYPE_KEY: string = 'type';
  public static MIB_IAI_TYPE: string = 'Type';
  public static MIB_IAI_STATUS_KEY: string = 'status';
  public static MIB_IAI_STATUS: string = 'Status';
  public static MIB_IAI_COVERAGE_KEY: string = 'coverage';
  public static MIB_IAI_COVERAGE: string = 'Coverage';
  public static MIB_IAI_RELATION_KEY: string = 'relation';
  public static MIB_IAI_RELATION: string = 'Relation';
  public static MIB_IAI_CARRIER_KEY: string = 'carrier';
  public static MIB_IAI_CARRIER: string = 'Carrier';
  /* MIB SECTION END */

  /* LETTER SECTION START */
  public static TASK_TITLE_LETTER: string = 'Letter';
  public static OTAF_LETTER: string = 'OTAF letter';
  public static DECLINE_LETTER: string = 'Decline letter';
  public static SUBSTANDARD_LETTER = 'Substandard Approval Letter';
  public static LETTER_OF_REINSTATEMENT = 'Letter of Reinstatement';
  public static REINSTATEMENT_DECLINE_LETTER = 'Reinstatement Decline Letter';
  public static REINSTATEMENT_WITHDRAWN_LETTER =
    'Reinstatement Withdrawn Letter';
  public static RUW_WITHDRAWL_LETTER = 'Withdrawal Letter';
  /* LETTER SECTION END */

  /* ERROR SECTION START*/
  public static NETWORK_ERROR: string = 'Network Error !';
  public static UPLOAD_ERROR: string = 'File Upload Error !';
  public static DELETE_ERROR: string = 'File Delete Error !';
  public static FORBIDDEN_ERROR: string = `You don't currently have permission to take this action`;
  public static INVALID_TRANSITION_ERROR =
    'Task state has changed. Please refresh the page.';
  /* ERROR SECTION END */

  /* RX SECTION START */
  public static TASK_TITLE_RX: string = 'Rx History';
  public static RX_HIT_TYPE: string = 'Hit Type';
  public static RX_HIT_TYPE_NO_HIT: string = 'No Hit';
  public static RX_HIT_TYPE_HIT: string = 'Hit';
  public static RX_CLEAR: string = 'Clear';
  public static RX_APPLICANT_NAME: string = 'Name';
  public static RX_APPLICANT_GENDER_AND_AGE: string = 'Gender & Age';
  public static RX_APPLICANT_BIRTH_DATE: string = 'Birthdate';
  public static RX_MAX_SEVERITY: string = 'Risk Score';
  public static RX_COUNT: string = 'Count';
  public static RX_HIGH: string = 'High';
  public static RX_MEDIUM: string = 'Medium';
  public static RX_LOW: string = 'Low';
  public static RX_STATUS_NO_HIT = 'no_hit';
  public static RX_RULES: string = 'Irix Rules';
  public static RX_RULE_INITIAL_PAGE_SIZE: number = 12;
  public static RX_RULE_SHOW_ALL: string = 'Show all';
  public static RX_RULE_SHOW_LESS: string = 'Show less';

  /* RX SECTION END */

  public static GENDER_FEMALE: string = 'Female';
  public static GENDER_MALE: string = 'Male';

  /* ACCEPT TERMS AND CONDITIONS MODAL */
  public static TNC_TITLE = 'Welcome to the Ethos Workbench';
  public static TNC_BODY_1 = 'By clicking Accept, you agree to the Ethos ';
  public static TNC_URL_TEXT = 'Terms of Use';
  public static TNC_URL = 'https://www.ethoslife.com/workbench-terms/';
  public static TNC_BODY_2 =
    ' which will govern this and all future uses of this workbench, and that this workbench is proprietary intellectual property of Ethos.';
  public static TNC_BUTTON = 'Accept';
  /* ACCEPT TERMS AND CONDITIONS MODAL END */
  public static DEFUNCT: string = '(Defunct)';
  public static APPLICATION_TITLE: string = 'Ethos Workbench';
  public static APPLICATIONS: string = 'Applications';
  public static PAGE_NOT_FOUND: string = 'Page not found';
  public static DOC_INFO_TITLE: string = 'Doctor (Post Issue APS)';
  public static AMENDMENT_TITLE: string = 'Amendment';
  public static REVIEW_STATUS_TITLE: string = 'Review Status';
  public static MIB_CODES_TITLE: string = 'MIB Codes';
  public static DECLINE_TITLE: string = 'Decline Reason';
  public static POSTPONE_TITLE: string = 'Postpone Reason';
  public static DISAGREEMENT_REASON: string = 'Disagreement Reason';
  public static OTAF_TITLE: string = 'OTAF Reason';
  public static UPDATE_TITLE = 'Update reason';
  public static INELIGIBLE_TITLE = 'Ineligible reason';
  public static SELECT_PLACEHOLDER = 'Select an option';
  public static REPULL_EVIDENCE = 'Re-pull evidence';
  public static REPULL_AI_SUMMARY = 'Re-pull AI summary';
  public static MARK_OUTDATED = 'Mark evidence as outdated';
  public static TASK_DESCRIPTION_CRIMINAL_RECORDS =
    'A summary of criminal history; arrests and convictions.';
  public static TASK_DESCRIPTION_ADDITIONAL_CUSTOMER_INFO =
    'A summary of additional information disclosed by customer.';
  public static TASK_DESCRIPTION_SPECIAL_AUTHORIZATION =
    'A task to upload Special Authorization form obtained from Exam One.';
  public static TASK_DESCRIPTION_PLAN_F = 'A task to upload Plan F details.';
  public static TASK_DESCRIPTION_SCRIPT_CHECK =
    'A comprehensive report of laboratory tests previously ordered by physicians.';
  public static TASK_DESCRIPTION_MEDICAL_CLAIMS =
    'History of insurance claims made for medical procedures and visits.';
  public static TASK_DESCRIPTION_LAB_PIQTURE =
    'A detailed report of an applicant’s prescription drug use.';
  public static TASK_DESCRIPTION_MIB_CODE_DETAILS =
    'Please go to www.MIB.com/portal to request MIB code details. Only one MIB code can be ordered per task.';
  public static TASK_DESCRIPTION_INSURANCE_LABS =
    'Medical exams previously ordered for insurance purposes.';
  public static TASK_DESCRIPTION_AUTO_MEDICAL_CLAIMS =
    'History of insurance claims made for medical procedures and visits. Automated order from Milliman';
  public static TASK_DESCRIPTION_TRL =
    'Finanial data of applicant. Automated order from TransUnion';
  public static TASK_DESCRIPTION_DISPUTE =
    'A task for working on cases migrated from PPWB for dispute resolution / QA';
  public static TASK_DESCRIPTION_ADDITIONAL_DOCUMENTS =
    'A summary of additional documents uploaded.';
  public static AUTOMATED_EVIDENCE_TITLE = 'Raw Evidence';
  public static USER_NOT_ASSIGNED = 'Not Assigned';
  public static CRIMINAL_RECORDS_RESULT = 'Result';
  public static CRIMINAL_RECORDS_CATEGORY = 'category';
  public static CRIMINAL_RECORDS_SUBCATEGORY = 'subcategory';
  public static CRIMINAL_RECORDS_DESCRIPTION = 'description';
  public static CRIMINAL_RECORDS_SEVERITY = 'severity';
  public static CRIMINAL_RECORDS_DISPOSITION = 'disposition';
  public static CRIMINAL_RECORDS_DATE = 'records date';
  public static CRIMINAL_RECORDS_SOURCE = 'source';
  public static START_PIA = 'Start Post Issue Audit';
  public static INITIATE_PIA = 'Initiate Post Issue Audit';
  public static INITIATE_REINSTATEMENT = 'Initiate Reinstatement';
  public static POLICY_NUMBER = 'Policy Number';
  public static POLICY_COMBINED = 'Policy Combined';
  public static HIPAA_AUTH_FORM = 'Hipaa Authorization Form';
  public static AUTO_MEDICAL_CLAIMS_VIEW = 'View Medical Claim';
  public static AUTO_MEDICAL_CLAIMS_MILLIMAN_PORTAL = 'Milliman Portal Link';
  public static AUTO_MEDICAL_CLAIMS_ORDER_RESULT = 'Result';
  public static RELEASE_TRANSFER_AUTHORIZATION =
    'Release Transfer Authorization';
  public static QE_INTERVIEW_QNA = 'QE interview Q&A';
  public static DELETE_ATTACHMENT = 'Delete Attachment';
  public static DELETE_ATTACHMENT_CONFIRMATION_TEXT =
    'You are about to delete this letter. Confirm?';
  public static DELETE_NOTE = 'Delete Note';
  public static DELETE_NOTE_CONFIRMATION_TEXT =
    'You are about to delete this note. Confirm?';
  public static CONFIRM = 'Confirm';
  public static SHOW_PII: string = 'Show PII';
  public static HIDE_PII: string = 'Hide PII';
  public static HIDDEN_STRING_TEXT: string = 'XXXXXXXXXX';
  public static REPULL_CARRIER_ELIGIBILITY = 'Re-pull carrier eligibility';

  /* PEER REVIEW SECTION START */
  public static PEER_REVIEW: string = 'Peer Review';
  public static PEER_REVIEW_DESCRIPTION: string =
    'See and edit the Peer Review assignments below.';
  public static PEER_REVIEWER: string = 'Peer Reviewer';
  public static TASK_TITLE_ADDITIONAL_DOCUMENTS = 'Additional Documents';
}
